import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/profile/arrow_right_white45.png'


const _hoisted_1 = { class: "menu-section" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "menu-left" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "menu-text" }
const _hoisted_6 = {
  key: 0,
  class: "sub_text"
}
const _hoisted_7 = {
  key: 1,
  class: "sub_text"
}
const _hoisted_8 = {
  key: 0,
  class: "unreadCount"
}

import { ref, inject, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user';
import { clickOnMenuThemeThree, MENU_LIST_THEME_THREE, MENU_LIST_THEME_TWO } from '@/view/profile/supportScript'
import ContactServicePopup from '@/view/profile/contactServicePopup.vue'
import { useActivityStore } from '@/stores/activity'

export default /*@__PURE__*/_defineComponent({
  __name: 'menuCard',
  emits: ['logout'],
  setup(__props, { emit: __emit }) {

const activityStore = useActivityStore()
const router = useRouter()
const menuList = ref(MENU_LIST_THEME_THREE)
const contactServiceRef = ref()
const poppingIndex = ref<number | null>(null)
const emits = __emit
const openLogoutPopup = inject<() => void>('openLogoutPopup')
const userStore = useUserStore()
const unreadMsgCount = computed(() => userStore.unreadCount)

const handleLogoutClick = () => {
  openLogoutPopup?.()
}

const onMenuClick = (path: string | null, index: number) => {
  clickOnMenuThemeThree(router, poppingIndex, contactServiceRef, handleLogoutClick, path, index)
}

const checkMenuShow = (index: number) => {
  if (index === 2) {
    const isAvailableRedeem = activityStore.activityList.some((obj: any) => obj.name === "redeem_code")
    if (isAvailableRedeem) {
      return true
    } else {
      return false
    }
  }

  return true
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuList.value, (item, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        (checkMenuShow(index))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "menu-card",
              onClick: ($event: any) => (onMenuClick(item.path, index))
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("img", {
                  src: item.img,
                  alt: "",
                  class: "menu-icon"
                }, null, 8, _hoisted_4),
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t(item.name)), 1),
                (item.msg && item.isHaveIcons)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString('🔴 '+ _ctx.$t(item.msg) +' 🎁'), 1))
                  : _createCommentVNode("", true),
                (item.msg && !item.isHaveIcons)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t(item.msg)), 1))
                  : _createCommentVNode("", true)
              ]),
              (item.isSupport && unreadMsgCount.value>0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(unreadMsgCount.value), 1))
                : _createCommentVNode("", true),
              _cache[0] || (_cache[0] = _createElementVNode("img", {
                src: _imports_0,
                alt: "",
                class: "arrow-icon"
              }, null, -1))
            ], 8, _hoisted_2))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}
}

})